export enum EmploymentType {
  EMPLOYEE = 'Employee',
  BUSINESS = 'Business'
}
